import React, { memo } from 'react'
import styles from './Field.module.css'

function Field({
  label,
  name,
  value,
  onChange,
  type = 'text',
  autoComplete = 'off',
  required = true,
  theme,
}) {
  const groupClass = [styles.form__group, styles.field, theme === 'parchment' ? styles.parchment : '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={groupClass}>
      <input
        type={type}
        id={name}
        name={name}
        className={styles.form__field}
        value={value ?? ''}
        placeholder={label}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
      />
      <label htmlFor={name} className={styles.form__label}>
        {label}
      </label>
    </div>
  )
}

export default memo(Field)
